import React from 'react';
import ReactDOM from 'react-dom/client';
import {v4 as guid} from 'uuid';
import App from './common/components/core/App';
import {setToken, setUser} from './modules/Auth';
import {logoutChannel, tabManager} from './common/utils';
import {appStore} from './store/configureStore';
import reportWebVitals from './reportWebVitals';
import './index.css';

const tabID = guid();

window.addEventListener('load', () => {
  tabManager.addTab(tabID);
});

window.addEventListener('unload', () => {
  const tabsCount = tabManager.removeTab(tabID).tabsCount();

  if (tabsCount <= 0) {
    tabManager.purge();
    logoutChannel.postMessage('Logout').catch(console.error);
    appStore.dispatch(setUser(null));
    appStore.dispatch(setToken(''));
  }
});

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <React.StrictMode>
    <App/>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
